export class Indicator {

  constructor(
    public unique_id: string, // unique id
    public type: number, // 0=visitas, 1=iteraciones, 2=tiempo
    public minutes: number, // 0 cuando no es de tipo 0
  ) {}
}



// WEBPACK FOOTER //
// ./src/app/models/indicator.ts